<template>
  <div class="terms-modal-overlay" v-if="isOpen">
    <div class="terms-modal-content">
      <h3 class="terms-modal-title">BKMS｜ブクマすをご利用いただく前に</h3>
      
      <div class="terms-modal-body">
        <p class="terms-description">
          このサービスは、<strong>最大90個のブックマークを手軽に整理・管理できるWebツール</strong>です。<br>
          データは<strong>サーバーに一切保存せず、お使いのブラウザ内で完結させることもできます</strong>。そのため、安心してご利用いただけます。
        </p>
        
        <p class="terms-warning">
          ただし、<strong>端末の故障やブラウザの不具合などに備えて、定期的に「エクスポート」でバックアップを取りましょう</strong>。<br>
          エクスポートしたデータは、別のPCやスマートフォンでも「インポート」すれば復元できます。
        </p>

        <p class="terms-warning">
          <strong>クラウド保存にも対応しています。</strong>。<br>
          保存後に表示されるURLを使えば、別環境でも同じブックマークを利用することができます。
        </p>
        
        <p class="terms-agreement">
          ご利用にあたっては、<a href="#" @click.prevent="showTerms">利用規約</a>をご確認ください。<br>
          「利用する」ボタンを押すことで、利用規約に同意したものとみなされます。
        </p>
      </div>
      
      <div class="terms-modal-buttons">
        <button 
          class="terms-agree-button" 
          @click="acceptTerms"
          :disabled="isAccepting"
        >{{ isAccepting ? '処理中...' : '利用する' }}</button>
      </div>
    </div>
  </div>
  
  <!-- 利用規約の詳細ポップアップ -->
  <TermsContent v-if="isTermsOpen" @close="isTermsOpen = false" />
</template>

<script>
import TermsContent from './TermsContent.vue';

export default {
  name: 'TermsModal',
  components: {
    TermsContent
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  // emitsプロパティを追加して、発生させるイベントを明示的に宣言
  emits: ['accept'],
  data() {
    return {
      isTermsOpen: false,
      isAccepting: false  // 処理中フラグを追加
    };
  },
  methods: {
    acceptTerms() {
      if (this.isAccepting) {
        return;
      }
      
      this.isAccepting = true;
      
      // Cookieに合意の証拠を保存する
      const expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 1); // 1年間有効
      document.cookie = `bkms_terms_agreed=true; expires=${expiryDate.toUTCString()}; path=/`;
      
      // ローカルストレージにも保存（バックアップとして）
      localStorage.setItem('bkms_terms_agreed', 'true');
      
      // 親コンポーネントに通知
      this.$emit('accept');
      
      // 処理完了後にフラグをリセット
      setTimeout(() => {
        this.isAccepting = false;
      }, 1000);
    },
    showTerms() {
      this.isTermsOpen = true;
    }
  }
};
</script>

<style scoped>
.terms-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
}

.terms-modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
}

.terms-modal-title {
  text-align: center;
  margin-top: 0;
  margin-bottom: 25px;
  color: #333;
  font-size: 1.5rem;
}

.terms-modal-body {
  margin-bottom: 25px;
  line-height: 1.6;
}

.terms-description, .terms-warning, .terms-agreement {
  margin-bottom: 20px;
}

.terms-modal-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.terms-agree-button {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  border-radius: 50px;
  padding: 12px 35px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.terms-agree-button:hover {
  background-color: #d9b6ab;
}

a {
  color: #e9937d;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .terms-modal-content {
    padding: 20px;
  }
  
  .terms-modal-title {
    font-size: 1.3rem;
  }
}
</style>